import React from "react";
import {TableLink} from "peggirkit";
import {FormattedMessage} from "react-intl";
import {DeliveryArea} from "@/data/entities/deliveryArea";
import {SetStateFn} from "@/utils/SetStateUtils";
import {DeleteDeliveryAreaState} from "@widgets/deliveryAreas/delete/DeleteDeliveryAreaModal";
import EditButton from "@widgets/deliveryAreas/overview/table/EditButton";
import {EditDeliveryAreaState} from "@widgets/deliveryAreas/edit/EditDeliveryAreaModal";

type Props = {
    deleteDeliveryAreaState: SetStateFn<DeleteDeliveryAreaState>,
    editDeliveryAreaState: SetStateFn<EditDeliveryAreaState>,
    deliveryArea: DeliveryArea,
};

const OptionsFormatter = ({deleteDeliveryAreaState, editDeliveryAreaState, deliveryArea}: Props) => {
    return (
        <div className={"flex flex-row flex-nowrap items-center justify-end gap-6"}>
            <TableLink
                color={"danger"}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: e => {
                            e.preventDefault();
                            deleteDeliveryAreaState({showModal: true, deliveryArea});
                        },
                    }
                }}
            >
                <FormattedMessage id={"delete"}/>
            </TableLink>

            <EditButton
                deliveryArea={deliveryArea}
                editDeliveryAreaState={editDeliveryAreaState}
            />
        </div>
    );
};

export default OptionsFormatter;